export const config = {
  API_URL: process.env.REACT_APP_SERVER_API_URL,
  APP_URL: process.env.REACT_APP_SERVER_URL,
  EDITOR_API_KEY: process.env.REACT_APP_EDITOR_API_KEY,
  paginationRowsPerPageOptions: [
    2, 5, 10, 20, 50, 100, 200
  ]
};
